import { SimpleEventDispatcher } from "strongly-typed-events";
export class AdsBase {
    constructor() {
        Object.defineProperty(this, "intersection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
}
Object.defineProperty(AdsBase, "PUSHDOWN_INDEX", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "7004"
});
Object.defineProperty(AdsBase, "POSITION_ATTRIBUTE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "data-position"
});
Object.defineProperty(AdsBase, "ADSPLIT_ATTRIBUTE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "data-split"
});
Object.defineProperty(AdsBase, "SELECTORS", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        adSlots: "component-ad-unit:not(.initialized)",
        collapse: "ad-collapse",
        lazyLoad: "lazy-load",
        initialized: "initialized",
        refresh: "viewport-refresh",
    }
});
export class GPTUtilsBase {
    constructor() {
        Object.defineProperty(this, "active", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "configuredSlots", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "pendingPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "_onSlotRendered", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
        Object.defineProperty(this, "refreshInProgress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    get onSlotRendered() {
        return this._onSlotRendered.asEvent();
    }
}
//# sourceMappingURL=ads.js.map